import { render, staticRenderFns } from "./wsqRight.vue?vue&type=template&id=49714cc0&scoped=true&"
import script from "./wsqRight.vue?vue&type=script&lang=js&"
export * from "./wsqRight.vue?vue&type=script&lang=js&"
import style0 from "./wsqRight.vue?vue&type=style&index=0&id=49714cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49714cc0",
  null
  
)

export default component.exports